// ignore-string-externalization

import styled from 'styled-components';
import {
  spacer12,
  spacer20,
  spacer40,
  spacer64,
  white,
  IconMenu,
  Type,
  cssColorValue,
  ButtonTertiary,
} from '@spotify-internal/encore-web';
import { getLinkStyle } from '../../ui';

export const OpenSideMenuButton = styled(IconMenu)`
  vertical-align: top;
  transform: scale(1.25);
  &:hover {
    cursor: pointer;
  }
`;

export const CloseSideMenuButton = styled(ButtonTertiary)`
  position: absolute;
  top: ${spacer12};
  right: ${spacer12};
  color: ${white};
  &:hover {
    cursor: pointer;
  }
`;

export const SideMenuLink = styled(Type).attrs({
  variant: 'celloCanon',
  weight: 'bold',
})``;

export const SideMenuAction = styled(Type).attrs({
  variant: 'celloCanon',
  weight: 'book',
})``;

export const SidemenuSeparator = styled.div`
  width: ${spacer40};
  height: 0;
  border-top: 1px solid ${cssColorValue('decorativeSubdued')};
  /* in addtion to li spacing: */
  margin-top: ${spacer12};
  margin-bottom: ${spacer12};
`;

export const SideMenuCategory = styled(Type).attrs({
  variant: 'celloCanon',
  weight: 'bold',
})``;

export const SideMenuCategoryTitle = styled(Type).attrs({
  variant: 'celloCanon',
  weight: 'bold',
})`
  svg {
    margin-left: ${spacer12};
    vertical-align: baseline;
  }
`;

export const SideMenuCategoryItem = styled(Type).attrs({
  variant: 'ballad',
  weight: 'book',
})`
  [dir='rtl'] & * {
    direction: rtl;
    & > svg {
      transform: rotateY(180deg);
    }
  }
  svg {
    vertical-align: -3px;
  }
`;

export const StyledSideMenu = styled.nav`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 320px;
  padding: ${spacer64} ${spacer20} ${spacer20} ${spacer20};
  background: ${props => props.theme.nav.sideMenuBackground};
  z-index: 1041; /* over the backdrop */
  overflow: auto;

  display: flex;
  flex-direction: column;
  &,
  a,
  a:visited,
  button span,
  button svg {
    color: ${props => props.theme.nav.sideMenuTextColor};
  }

  ${SideMenuCategory} {
    a,
    button {
      ${(props: any) => getLinkStyle(props)}
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    flex: 1;
    li {
      width: 100%;
      margin-bottom: ${spacer20};

      /* sub menu */
      ul {
        margin-top: ${spacer20};
        padding-bottom: 0;
        li {
          margin-left: ${spacer20};
        }
        li:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  ul,
  ol {
    list-style: none;
    padding-left: 0;
  }
`;
